export const FORMATS = [
    {
        value: 'image',
        label: 'Image'
    },
    {
        value: 'pdf',
        label: 'PDF'
    },
    {
        value: 'hard_copy',
        label: 'Hard Copy'
    },
    {
        value: 'excel',
        label: 'Excel'
    },
    {
        value: 'word',
        label: 'Word'
    },
]